/**
 * Purchasing Settings Tab - Reason Codes management.
 * Note: Commodity Groups and Types have been moved to Platform tab per client request.
 */

import { ReasonCodesSection } from './ReasonCodesSection';
import { PurchasingEmailNotificationsSection } from './PurchasingEmailNotificationsSection';
import { OpenOrdersSection } from './OpenOrdersSection';
import { AutoApproveDeliveryAppealSection } from './AutoApproveDeliveryAppealSection';

export function PurchasingTab() {
  return (
    <div className="space-y-6">
      {/* Email Notifications (CR-4421) */}
      <PurchasingEmailNotificationsSection />

      {/* Open Orders visibility (CR-4422) */}
      <OpenOrdersSection />

      {/* Auto Approve Delivery Appeal (CR-4423) */}
      <AutoApproveDeliveryAppealSection />

      {/* Reason Codes */}
      <ReasonCodesSection />
    </div>
  );
}
